import { createSlice } from "@reduxjs/toolkit";
import { todayDataReducer } from "../extraReducers/todayDataReducer";

// 定义初始化数据
const initialState = {
  userCount: "" as string,
  groupCount: "" as string,
  newAddUser: [] as any,
  newAddGroup: [] as any,
  loginRecord: [] as any,
  transferMoneyAmount: [] as any,
  redEnvelopeAmount: [] as any,
};

const todayDataSlice = createSlice({
  name: "todayData",
  initialState,
  reducers: {},
  extraReducers: todayDataReducer,
});

// 默认导出,到处的文件需要在store入口文件引入
export default todayDataSlice.reducer;
